<template>
  <div id="typeAhead">
    <multiselect ref="m-select" @select="itemSelected" v-model="selectedValue" :placeholder="placeholder" :options="suggestions" :custom-label="(option) => displayString(option)" :multiple="false" :searchable="true" :loading="isLoading" :internal-search="internalSearch" :max-height="600" :show-no-results="true" :hide-selected="false" @search-change="displayMatches" :close-on-select="true" :preserve-search="false" :preselectFirst="false">
      <div slot="noResult">
        <p>No Results found. Try a different search query.</p>
        <button v-if="allowClear" class="b btn-link mt-2 text-sm" @click="clearResult">Remove current selection.</button>
      </div>
      <div slot="noOptions" class="">
        <p>List is empty. Start typing to search.</p>
        <button v-if="allowClear" class="b btn-link mt-2 text-sm" @click="clearResult">Remove current selection.</button>
      </div>
    </multiselect>

    <!--<input type="text" v-model="searchValue" class="text-input shadow focus:outline-none focus:shadow-outline" id="search" aria-describedby="emailHelp" :placeholder="placeholder" autocomplete="off" v-on:keyup="displayMatches" v-on:blur="resetComponent">
    <div id="suggestionBox">
      <ul class="suggestions shadow-lg" id="suggestionList">
        <li v-for="s in suggestions" :key="s[schema.idField]" @mousedown="itemSelected(s)">
          {{displayString(s)}}
        </li>
      </ul>
    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    schema: Object,
    // Assumes data is already in desired sort order
    listData: Array,
    placeholder: String,
    label: String,
    dataEndpoint: String,
    internalSearch: {
      type: Boolean,
      default: true
    },
    initialValue: {
      type: Object,
      default: () => {}
    },
    allowClear: {
      type: Boolean,
      default: false
    }
    /* suggestions: {
      type: Array,
      default: () => []
    } */
  },
  data () {
    return {
      loaded: '123456',
      suggestions: [],
      searchValue: '',
      selectedValue: '',
      isLoading: false
    }
  },
  methods: {
    /* findMatches (wordToMatch) {
      return this.listData.filter(d => {
        // here we need to figure out if the city or state matches what was searched
        const regex = new RegExp(wordToMatch, 'gi')
        return d[this.schema.searchField1].match(regex) || d[this.schema.searchField2].match(regex)
      })
    }, */
    findMatches (wordToMatch) {
      if (this.dataEndpoint) {
        // this.axios.get(this.dataEndpoint + `?search_text=${this.searchValue}`)
        this.isLoading = true
        this.apiInstance.get(this.dataEndpoint + `?search_text=${this.searchValue}`)
          .then(response => {
            this.suggestions = response.data.data ? response.data.data : []
            this.isLoading = false
          })
          .catch(() => {
            // this.$honeybadger.notify(error)
          })
      } else {
        this.suggestions = this.listData.filter(d => {
          // here we need to figure out if the city or state matches what was searched
          let value = wordToMatch.trim().replace(/\\+/g, '')
          const regex = new RegExp(value, 'gi')
          return d[this.schema.searchField1].match(regex) || d[this.schema.searchField2].match(regex)
        })
      }
    },
    displayMatches (event) {
      this.searchValue = event
      if (this.searchValue === '') {
        this.suggestions = [] // this.listData
        return
      }
      this.findMatches(this.searchValue)
    },
    itemSelected (selected) {
      this.suggestions = [] // this.listData
      this.selectedValue = selected // selected[this.schema.idField]
      this.$emit('input', this.selectedValue)
      this.$emit('valueChange', selected)
    },
    initValue () {
      if (this.initialValue) {
        this.selectedValue = this.initialValue
      }
    },
    displayString (value) {
      var str = this.schema.displayTemplate

      this.schema.displayFields.forEach((f, i) => {
        var val = null
        if (f.func) {
          val = f.func(value[f.value])
        } else {
          val = value[f]
        }
        str = str.replace(`$${i + 1}`, val)
      })
      return str
    },
    resetComponent () {
      this.suggestions = []
      // this.suggestions = this.listData
    },
    clearResult () {
      this.suggestions = [] // this.listData
      this.selectedValue = null // selected[this.schema.idField]
      this.$emit('input', this.selectedValue)
      this.$emit('valueChange', null)
      this.$refs['m-select'].deactivate()
    }
  },
  computed: {
    apiInstance () {
      return this.$store.state.apiInstance
    }
  },
  mounted () {
    this.initValue()
  }
}
</script>

<style>
  #suggestionBox{
    position: relative;
  }
  .suggestions {
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 9999;
    width: 100%;
    /*perspective:20px;*/
  }
  .suggestions li {
    background:white;
    color: black;
    list-style: none;
    border-bottom: 1px solid #D8D8D8;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.14);
    margin:0;
    padding:20px;
    /*transition: background 0.2s;
    display:flex;*/
    justify-content:space-between;
    text-transform: capitalize;
  }
  .suggestions li:hover{
    background: #eee;
    font-weight: bold;
  }
  .suggestions li:nth-child(even) {
    transform: perspective(100px) rotateX(3deg) translateY(2px) scale(1.001);
    background: linear-gradient(to bottom,  #ffffff 0%,#EFEFEF 100%);
  }
  .suggestions li:nth-child(odd) {
    transform: perspective(100px) rotateX(-3deg) translateY(3px);
    background: linear-gradient(to top,  #ffffff 0%,#EFEFEF 100%);
  }
</style>
